import apiSubmitTweet from '../../utils/tweet/tweetApi';

import {
    ACTION_INITIATED_LOCAL_REP,
    ACTION_COMPLETED_LOCAL_REP
} from '../Widget/actions';

export const TWEET_SUCCESS = 'TWEET_SUCCESS';
export const TWEET_INITIATED = 'TWEET_INITIATED';
export const SET_SUCCESS_INFO = 'SET_SUCCESS_INFO';

const initiatedActionIndentifiers = [];
const completedActionIdentifiers = [];

export const initTweet = (apiRequestData, actionIdentifier) => dispatch => {
    if (
        initiatedActionIndentifiers.find(identifier => identifier === apiRequestData.id)
    ) {
        return;
    }
    dispatch({
        type: ACTION_INITIATED_LOCAL_REP,
        payload: actionIdentifier
    });

    initiatedActionIndentifiers.push(apiRequestData.id);
};

export const onCompleteTweet = (
    apiRequestData,
    actionCompletedTime,
    actionIdentifier,
    thankYouText,
    thankYouTitle,
    useLocalRepresentative,
    localRepresentativeState
) => dispatch => {
    if (completedActionIdentifiers.find(identifier => identifier === apiRequestData.id)) {
        return;
    }

    dispatch({
        type: TWEET_INITIATED,
        payload: { actionIdentifier }
    });

    apiSubmitTweet(apiRequestData, actionCompletedTime).then(data => {
        dispatch({
            type: TWEET_SUCCESS,
            payload: {
                ...data,
                actionIdentifier,
                thankYouText,
                useLocalRepresentative,
                localRepresentativeState
            }
        });

        dispatch({
            type: SET_SUCCESS_INFO,
            payload: {
                thankYouText,
                thankYouTitle,
                useLocalRepresentative,
                localRepresentativeState,
                apiRequestData
            }
        });

        dispatch({
            type: ACTION_COMPLETED_LOCAL_REP,
            payload: actionIdentifier
        });
    });

    completedActionIdentifiers.push(apiRequestData.id);
    return true;
};
